export const IDEATIONSTATUS = {
  Publish: 'Publish',
  Draft: 'Draft',
}
